<template>
    <div class="wrapper">
        <div class="text">TESTIMONIALS</div>
        <div class="title">Proffesionalism in punctuality & quality build
            great long term relationship</div>
        <div class="reviews__list">
            <div class="item" v-for="item in array">
                <img :src="`${this.$store.state.base_directory}${item.avatar.replace(/^public\//, '')}`" alt="">
                <div class="name">{{item.author}}</div>
                <div class="position">{{item.position}}</div>
                <div class="stars">
                        <svg v-for="item in isHalfStar(item.rating)" width="12.000000" height="12.000000" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <defs>
                                <clipPath id="clip511_3540">
                                    <rect id="Frame" rx="0.000000" width="11.000000" height="11.000000" transform="translate(0.500000 0.500000)" fill="white" fill-opacity="0"/>
                                </clipPath>
                            </defs>
                            <rect id="Frame" rx="0.000000" width="11.000000" height="11.000000" transform="translate(0.500000 0.500000)" fill="#FFFFFF" fill-opacity="0"/>
                            <g clip-path="url(#clip511_3540)">
                                <path id="Vector" d="M0 0L12 0L12 12L0 12L0 0Z" fill="#FFFFFF" fill-opacity="0.010000" fill-rule="evenodd"/>
                                <path id="Vector" d="M5.99 1.25L4.47 4.36L1 4.87L3.51 7.33L2.91 10.75L5.99 9.1L9.08 10.75L8.48 7.33L11 4.87L7.54 4.36L5.99 1.25Z" fill="#FFB710" fill-opacity="1.000000" fill-rule="nonzero"/>
                                <path id="Vector" d="M4.47 4.36L1 4.87L3.51 7.33L2.91 10.75L5.99 9.1L9.08 10.75L8.48 7.33L11 4.87L7.54 4.36L5.99 1.25L4.47 4.36Z" stroke="#FFB710" stroke-opacity="1.000000" stroke-width="1.250000" stroke-linejoin="round"/>
                            </g>
                        </svg>

                        <svg v-for="item in 5-isHalfStar(item.rating)" width="12.000000" height="12.000000" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <defs>
                                <clipPath id="clip511_3534">
                                    <rect id="Frame" rx="0.000000" width="11.000000" height="11.000000" transform="translate(0.500000 0.500000)" fill="white" fill-opacity="0"/>
                                </clipPath>
                            </defs>
                            <rect id="Frame" rx="0.000000" width="11.000000" height="11.000000" transform="translate(0.500000 0.500000)" fill="#FFFFFF" fill-opacity="0"/>
                            <g clip-path="url(#clip511_3534)">
                                <path id="Vector" d="M0 0L12 0L12 12L0 12L0 0Z" fill="#FFFFFF" fill-opacity="0.010000" fill-rule="evenodd"/>
                                <path id="Vector" d="M4.47 4.36L1 4.87L3.51 7.33L2.91 10.75L5.99 9.1L9.08 10.75L8.48 7.33L11 4.87L7.54 4.36L5.99 1.25L4.47 4.36Z" stroke="#D1D1D6" stroke-opacity="1.000000" stroke-width="1.250000" stroke-linejoin="round"/>
                            </g>
                        </svg>


                        <div class="number">{{item.rating}}</div>
                </div>
                <div class="coment">{{item.review}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            array: [Array, Object],
        },
        methods: {
            isHalfStar(e){
                return Math.floor(e);
            },
        },
    }
</script>

<style scoped>
.wrapper{
    padding-top: 88px;
}
.wrapper > .text{
/* Tabs/T1: 13px Medium */
color: rgb(85, 98, 114);
font-size: 13px;
font-weight: 500;
line-height: 140%;
letter-spacing: 0%;
text-align: left;
padding-bottom: 10px;
}
.wrapper > .title{
/* Header/H2: 32px Medium */
color: rgb(5, 5, 5);
font-size: 32px;
font-weight: 500;
line-height: 140%;
letter-spacing: 0%;
text-align: left;
padding-bottom: 30px;
}
.reviews__list{
    display: flex;
    gap: 32px;
    flex-wrap: wrap;
}
.reviews__list .item{
    width: calc((100% / 4) - 24px);
}
.item img{
    width: 100%;
    object-fit: cover;
    margin-bottom: 16px;
}
.item .name{
color: rgb(5, 5, 5);
font-size: 24px;
font-weight: 500;
line-height: 140%;
letter-spacing: 0%;
text-align: left;
padding-bottom: 4px;
}
.item .position{
  /* Paragraph/P3: 16px Regular */
color: rgb(5, 5, 5);
font-size: 16px;
font-weight: 400;
line-height: 140%;
letter-spacing: 0%;
text-align: left;  
padding-bottom: 12px;
}
.item .stars{
    display: flex;
    align-items: center;
    /* Header/H4: 16px Medium */
    color: rgb(5, 5, 5);
    font-family: Satoshi;
    font-size: 16px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: left;
    gap: 4px;
    margin-bottom: 10px;
}
.item .stars .number{
    padding-left: 8px;
}
.item .coment{
    color: rgb(5, 5, 5);
    font-size: 20px;
    font-weight: 400;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: left;
}
@media (max-width: 1024px) {
    .reviews__list .item{
    width: calc((100% / 2) - 16px);
    }
}
@media (max-width: 768px) {
    .reviews__list .item{
    width: 100%;
    }
}
</style>